export const encodeFiltersToQueryString = (filters) => {
  try {
    const jsonString = JSON.stringify(filters);
    const encodedString = btoa(jsonString);
    return encodeURIComponent(encodedString);
  } catch (e) {
    console.error('Error encoding filters to query string:', e);
    return '';
  }
}

export const decodeFiltersFromQueryString = (queryString) => {
  try {
    const decodedString = decodeURIComponent(queryString);
    const jsonString = atob(decodedString);
    return JSON.parse(jsonString);
  } catch (e) {
    console.error('Error decoding filters from query string:', e);
    return null;
  }
}

export const openAnalyticsWithFilters = (filters) => {

    const queryString = encodeFiltersToQueryString(filters);
    window.open(`/analytics?query=${queryString}`, '_self');
}